export default "__VITE_ASSET__CX$sx0Ur__"